(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wc-hide-seek"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wc-hide-seek')) {
    customElements.define('wc-hide-seek', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.key = 'wc-' + this.dataset.campaign;
        const source = new URLSearchParams(location.search).get('utm_source');
        const fromKlaviyo = source?.toLowerCase() === 'klaviyo';
        if (fromKlaviyo) this.write('sessionStorage', this.key + '-klaviyo', 'yes');
        this.allowed = fromKlaviyo || this.read('sessionStorage', this.key + '-klaviyo') === 'yes';
        this.toggleAttribute('data-klaviyo-visit', this.allowed);
        if (!this.allowed) return;
        this.abort = new AbortController();
        this.q = selector => this.querySelector(selector);
        this.invite = this.q('.whs-invite');
        this.dialog = this.q('.whs-dialog');
        this.scene = this.q('.whs-scene');
        this.storyResize = new ResizeObserver(() => {
          const height = this.q('.whs-story').getBoundingClientRect().height;
          if (height > 0) this.dialog.style.setProperty('--whs-story-height', height + 'px');
        });
        this.storyResize.observe(this.q('.whs-story'));
        this.sceneImage = this.q('.whs-scene-image');
        if (this.sceneImage) {
          this.listen(this.sceneImage, 'load', () => this.syncScene());
          if (this.sceneImage.complete) this.syncScene();
        }
        this.feedback = this.q('.whs-feedback');
        this.found = this.read('localStorage', this.key) === 'found';
        this.caught = this.found;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.q('.whs-bubble').textContent = this.found ? this.dataset.found : this.dataset.catch;
        this.listen(this.q('.whs-catch'), 'click', () => this.catchBox());
        this.listen(this.q('.whs-dismiss'), 'click', () => { this.invite.hidden = true; this.write('sessionStorage', this.key + '-dismissed', 'yes'); });
        this.listen(this.q('.whs-close'), 'click', () => this.dialog.close());
        this.listen(this.q('.whs-return'), 'click', () => this.dialog.close());
        this.listen(this.dialog, 'close', () => this.closed());
        this.listen(this.dialog, 'click', e => { if (e.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close(); } });
        this.listen(this.scene, 'pointermove', e => this.moveBeam(e));
        this.listen(this.scene, 'pointerdown', e => this.moveBeam(e));
        this.listen(this.scene, 'touchmove', e => { if (e.touches.length === 1) this.moveBeam(e.touches[0]); }, {passive:true});
        this.querySelectorAll('.whs-front').forEach(front => {
          this.listen(front, 'click', () => this.openDrawer(front.closest('.whs-drawer')));
          this.listen(front, 'focus', () => this.pointAt(front));
        });
        this.listen(this.q('.whs-secret'), 'click', () => this.reveal());
        this.listen(this.q('.whs-secret'), 'focus', () => this.pointAt(this.q('.whs-secret')));
        this.listen(this.q('.whs-skip'), 'click', () => this.reveal());
        this.listen(this.q('.whs-hint'), 'click', () => {
          const drawer = this.q('.whs-drawer-3');
          drawer.classList.add('is-hinted');
          this.feedback.textContent = this.dataset.hint;
          this.pointAt(drawer);
          drawer.scrollIntoView({block:'nearest', behavior:this.reduced ? 'instant' : 'smooth'});
        });
        this.listen(this.q('.whs-lights'), 'click', () => {
          const on = this.scene.classList.toggle('is-lit');
          this.q('.whs-lights').setAttribute('aria-pressed', String(on));
          this.q('.whs-lights').textContent = on ? this.dataset.lightsOff : this.dataset.lightsOn;
        });
        this.listen(this.q('.whs-copy'), 'click', () => this.copyCode());
        this.listen(this.q('.whs-replay'), 'click', () => this.resetGame());
        this.watchOffer();
        this.listen(window, 'hashchange', () => { if (location.hash === '#hide-and-seek') this.openGame(); });
        this.timer = setTimeout(() => {
          if (this.read('sessionStorage', this.key + '-dismissed') !== 'yes') this.invite.hidden = false;
          if (location.hash === '#hide-and-seek') this.openGame();
        }, 1300);
      }
      listen(target, type, fn, options = {}) { target.addEventListener(type, fn, {...options, signal:this.abort.signal}); }
      syncScene() {
        const source = this.sceneImage.currentSrc || this.sceneImage.src;
        if (source) this.scene.style.setProperty('--whs-photo', 'url("' + source + '")');
      }
      watchOffer() {
        this.offerRoots = new Set();
        this.offerShadows = new Map();
        this.queueOffer = () => {
          if (this.offerFrame) return;
          this.offerFrame = requestAnimationFrame(() => { this.offerFrame = null; this.positionAboveOffer(); });
        };
        this.offerResize = new ResizeObserver(this.queueOffer);
        this.offerChanges = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) this.queueOffer();
        });
        this.offerChanges.observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['style','class','hidden','aria-hidden']});
        this.listen(window, 'resize', this.queueOffer);
        this.listen(window, 'scroll', this.queueOffer, {passive:true});
        if (window.visualViewport) this.listen(window.visualViewport, 'resize', this.queueOffer);
        this.offerTimer = setInterval(this.queueOffer, 1500);
        this.queueOffer();
      }
      positionAboveOffer() {
        const roots = [...document.querySelectorAll('[id^="alia-root"], iframe[id*="alia"], iframe[title*="Alia"]')];
        const candidates = [];
        let modal = false;
        const visible = el => {
          const style = getComputedStyle(el), r = el.getBoundingClientRect();
          return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && r.width > 2 && r.height > 2 && r.bottom > 0 && r.top < innerHeight;
        };
        for (const root of roots) {
          if (!this.offerRoots.has(root)) { this.offerRoots.add(root); this.offerResize.observe(root); }
          if (!root.isConnected || getComputedStyle(root).display === 'none') continue;
          const scope = root.shadowRoot || root;
          if (root.shadowRoot && !this.offerShadows.has(root)) {
            const observer = new MutationObserver(this.queueOffer);
            observer.observe(scope, {subtree:true,childList:true,attributes:true,attributeFilter:['style','class','hidden','aria-hidden']});
            this.offerShadows.set(root, observer);
          }
          const nodes = [root, ...scope.querySelectorAll('[id^="alia-popup-root"], button, [role="button"], [role="dialog"], [aria-modal="true"]')];
          const hasInput = [...scope.querySelectorAll('input:not([type="hidden"]),select')].some(visible);
          for (const node of nodes) {
            if (!visible(node)) continue;
            const r = node.getBoundingClientRect();
            if ((node.matches('[role="dialog"],[aria-modal="true"]') || hasInput || node.id.startsWith('alia-popup-root')) && r.height > 180 && r.width > 220) modal = true;
            if (r.width >= 35 && r.width <= 480 && r.height >= 25 && r.height <= 170 && r.top > innerHeight * .35) {
              candidates.push({node,rect:r,priority:/mystery|offer/i.test(node.textContent || '') ? 1 : 0});
            }
          }
        }
        for (const root of this.offerRoots) {
          if (!root.isConnected) { this.offerResize.unobserve(root); this.offerRoots.delete(root); this.offerShadows.get(root)?.disconnect(); this.offerShadows.delete(root); }
        }
        this.invite.classList.toggle('is-offer-open', modal);
        candidates.sort((a,b) => b.priority-a.priority || b.rect.width*b.rect.height-a.rect.width*a.rect.height);
        const offer = candidates[0];
        if (!offer || modal) {
          if (!offer) for (const prop of ['--whs-launch-left','--whs-launch-bottom','--whs-hop']) this.invite.style.removeProperty(prop);
          return;
        }
        const width = innerWidth <= 700 ? 146 : 175;
        const height = innerWidth <= 700 ? 110 : 136;
        const gap = 16;
        const left = Math.min(innerWidth-width-28, Math.max(12,offer.rect.left+(offer.rect.width-width)/2));
        const bottom = innerHeight-offer.rect.top+gap;
        const hop = Math.max(0,Math.min(innerWidth <= 700 ? 52 : 62,offer.rect.top-gap-height-16));
        for (const [key,value] of Object.entries({'--whs-launch-left':left,'--whs-launch-bottom':bottom,'--whs-hop':hop})) {
          const next = Math.round(value)+'px';
          if (this.invite.style.getPropertyValue(key) !== next) this.invite.style.setProperty(key,next);
        }
      }
      read(type, key) { try { return window[type].getItem(key); } catch { return null; } }
      write(type, key, value) { try { window[type].setItem(key, value); } catch {} }
      catchBox() {
        if (this.caught || this.reduced) { this.openGame(); return; }
        this.caught = true;
        this.invite.classList.add('is-dodging');
        this.dodgeTimer = setTimeout(() => {
          this.invite.classList.add('is-caught', 'is-arriving');
          this.invite.classList.remove('is-dodging');
          this.q('.whs-bubble').textContent = this.dataset.follow;
          this.invite.getBoundingClientRect();
          this.entryFrame = requestAnimationFrame(() => {
            this.invite.classList.remove('is-arriving');
            this.q('.whs-catch').focus({preventScroll:true});
          });
        }, 200);
      }
      openGame() {
        if (!this.allowed || this.dialog.open) return;
        this.invite.hidden = true;
        document.documentElement.classList.add('whs-game-open');
        this.dialog.showModal();
        if (this.found) this.reveal(false);
      }
      closed() {
        document.documentElement.classList.remove('whs-game-open');
        this.positionAboveOffer();
        this.invite.hidden = false;
        this.q('.whs-catch').focus({preventScroll:true});
      }
      moveBeam(e) {
        if (this.frame) cancelAnimationFrame(this.frame);
        const x = e.clientX, y = e.clientY;
        this.frame = requestAnimationFrame(() => {
          const r = this.scene.getBoundingClientRect();
          this.scene.style.setProperty('--whs-x', Math.max(0, Math.min(100, (x-r.left)/r.width*100)) + '%');
          this.scene.style.setProperty('--whs-y', Math.max(0, Math.min(100, (y-r.top)/r.height*100)) + '%');
        });
      }
      pointAt(element) { const r = element.getBoundingClientRect(); this.moveBeam({clientX:r.left+r.width/2,clientY:r.top+r.height/2}); }
      openDrawer(drawer) {
        const wasOpen = drawer.classList.contains('is-open');
        this.querySelectorAll('.whs-drawer').forEach(d => {
          const open = d === drawer && !wasOpen;
          d.classList.toggle('is-open', open);
          d.querySelector('.whs-front').setAttribute('aria-expanded', String(open));
          d.querySelector('.whs-inside').hidden = !open;
        });
        this.pointAt(drawer);
        this.feedback.textContent = wasOpen ? '' : drawer.dataset.drawer === '1' ? this.dataset.firstNote : drawer.dataset.drawer === '2' ? this.dataset.secondNote : '';
        if (!wasOpen && drawer.dataset.drawer === '3') this.q('.whs-secret').focus({preventScroll:true});
      }
      reveal(save = true) {
        this.found = true;
        if (save) this.write('localStorage', this.key, 'found');
        this.q('.whs-playing').hidden = true;
        this.q('.whs-reward').hidden = false;
        this.dialog.classList.add('is-found');
        this.scene.classList.add('is-lit');
        this.q('.whs-bubble').textContent = this.dataset.found;
        this.q('.whs-reward h2').focus({preventScroll:true});
        this.dialog.scrollTop = 0;
        this.q('.whs-copy-status').textContent = this.dataset.foundStatus;
      }
      async copyCode() {
        try {
          await navigator.clipboard.writeText(this.dataset.code);
          this.q('.whs-copy-status').textContent = this.dataset.copied;
          this.q('.whs-copy').textContent = this.dataset.copied;
        } catch {
          this.q('.whs-code').focus();
          this.q('.whs-code').select();
          this.q('.whs-copy-status').textContent = this.dataset.copyManual;
        }
      }
      resetGame() {
        this.q('.whs-playing').hidden = false;
        this.q('.whs-reward').hidden = true;
        this.dialog.classList.remove('is-found');
        this.scene.classList.remove('is-lit');
        this.q('.whs-lights').setAttribute('aria-pressed', 'false');
        this.q('.whs-lights').textContent = this.dataset.lightsOn;
        this.querySelectorAll('.whs-drawer').forEach(d => {
          d.classList.remove('is-open', 'is-hinted');
          d.querySelector('.whs-front').setAttribute('aria-expanded', 'false');
          d.querySelector('.whs-inside').hidden = true;
        });
        this.feedback.textContent = '';
        this.q('.whs-front').focus({preventScroll:true});
      }
      disconnectedCallback() {
        this.abort?.abort();
        clearTimeout(this.timer);
        clearTimeout(this.dodgeTimer);
        cancelAnimationFrame(this.entryFrame);
        cancelAnimationFrame(this.frame);
        clearInterval(this.offerTimer);
        cancelAnimationFrame(this.offerFrame);
        this.offerChanges?.disconnect();
        this.offerResize?.disconnect();
        this.storyResize?.disconnect();
        this.offerShadows?.forEach(observer => observer.disconnect());
        if (this.dialog?.open) document.documentElement.classList.remove('whs-game-open');
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
